import axios from "axios";
import userStore from "@/store/userStore";
import store from "../store";
const backendUrl = store.state.baseUrl + "wp-json/";
import { EventBus } from "../mixins/event-bus.js";

const getApiUrl = (endpoint, external = false) => {
  let url = "";
  if (!external) {
    url = backendUrl + "gamelle/v1/" + endpoint;
  } else {
    url = endpoint;
  }
  return url;
};

const fetchAPI = {
  async get(endpoint) {
    const url = getApiUrl(endpoint);
    // Send request
    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  async delete(endpoint) {
    const url = getApiUrl(endpoint);
    // Send request
    return axios
      .delete(url)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  async post(endpoint, params) {
    const url = getApiUrl(endpoint);
    return axios
      .post(url, params)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  async validateToken(token) {
    if (token === null) {
      return false;
    }
    const url = backendUrl + "jwt-auth/v1/token/validate";
    let config = {};

    config = {
      headers: { Authorization: "Bearer " + token },
    };
    const params = {};
    return axios
      .post(url, params, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  async auth(endpoint, params) {
    let url;
    if (endpoint === "google") {
      url = backendUrl + "gamelle/v1/users/google-auth";
    } else {
      url = backendUrl + "jwt-auth/v1/" + endpoint;
    }
    return axios
      .post(url, params, {})
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  setAxiosHeaders() {
    if (userStore.state.token !== null) {
      axios.defaults.headers.common = {
        Authorization: `Bearer ${userStore.state.token}`,
      };
      EventBus.$emit("userInit", true);
    } else {
      EventBus.$emit("userInit", false);
    }
  },
};
export default fetchAPI;
